<template>
  <div class="c-check-list">
    <CCheckButton v-if="selectAll && availableOptions.length > 1" :active="availableOptions.every(isSelected)" @update:active="doSelectAll">
      <span class="u-medium">
        {{ $t('general.selectAll') }}
        <CCounter :count="availableOptions.length" class="u-ml-1"/>
      </span>
    </CCheckButton>

    <CCheckButton v-for="option in options" :disabled="isDisabled(option)" :active="isSelected(option)" @update:active="v => select(v, option)">
      <slot name="option" :option>
        <span>{{ option }}</span>
      </slot>
    </CCheckButton>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import CCheckButton from '../CCheckButton.vue';
  import CCounter from '../CCounter.vue';

  type Option = any;

  const props = defineProps<{
    options?: Array<Option>;
    disabledOptions?: Array<Option>;
    disabled?: boolean;
    selectAll?: boolean,
  }>();

  const model = defineModel<Array<Option>>();

  const availableOptions = computed(() => props.disabled ? [] : (props.options?.filter(o => !isDisabled(o)) ?? []));

  function select(active: boolean, option: Option): void {
    if (isSelected(option) === active) return;
    if (active) {
      model.value = [...model.value ?? [], option];
    } else {
      model.value = model.value?.filter(v => v !== option);
    }
  }

  function doSelectAll(active: boolean): void {
    model.value = active ? [...availableOptions.value] : [];
  }

  function isSelected(option: Option): boolean {
    return model.value?.includes(option) ?? false;
  }

  function isDisabled(option: Option): boolean {
    return props.disabled || (props.disabledOptions?.includes(option) ?? false);
  }
</script>

<style lang="scss">
  .c-check-list {
    .c-field-control:not(.c-menu .c-field-control) > & {
      padding: 0;
    }

    .c-check-button {
      width: 100%;
      flex-flow: row-reverse;

      &.c-button {
        border-radius: 0;
        padding: $input-padding;
        border: none;
        font-weight: inherit;
        justify-content: space-between;
      }

      &:not(:last-child) {
        border-bottom: 1px solid $input-border;
      }
    }
  }

  .c-check-list .c-button.c-button-light-primary:hover {
    background-color: #d5f0ff;
  }
</style>